// extracted by mini-css-extract-plugin
module.exports = {"optionalColumn":"Session_optionalColumn__b_2U_","filter":"Session_filter___Vwn0"};